import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { SectionState } from '@shared-features/enums/layout.enum';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  // private fields
  private loadingStatus = new Subject<SectionState>();

  // public fields
  public loadingStatus$ = this.loadingStatus.asObservable();

  constructor() { }

  // actions
  public startLoading(loadingStatus: SectionState) {
    this.loadingStatus.next(loadingStatus);
  }

  public stopLoading() {
    this.loadingStatus.next(SectionState.HideLoading);
  }
}
